module.exports = __webpack_public_path__ + "img/image165.b99bb519.jpg";